<template>
  <vue-modal :active="active" @closed="$emit('closed')">
    <report-orders type="vendor">
      <template slot-scope="{report}">
        <div class="break-inside-avoid mb-4 text-black text-sm leading-none" v-for="(labels, customer) in report" :key="customer">
          <h3 class="mb-1 text-black" v-text="customer"></h3>
          <div class="border border-black">
            <div class="label flex flex-col-reverse md:flex-row md:justify-between border-b border-black p-1" v-for="(label, index) in labels" :key="index" >
              <div class="flex-1">
                <div v-for="(product, index) in label.products" :key="index" class="mr-2 inline">
                  <span class="whitespace-no-wrap">
                    <svgicon name="cupcake-solid"/> {{ product.name }} x {{ product.pivot.quantity }}
                  </span>
                  <em v-if="product.pivot.note" class="text-xs">({{ product.pivot.note }})</em>
                </div>
              </div>
              <div class="flex justify-between items-baseline mb-1 md:mb-0 md:pl-2">
                <small class="font-mono">{{ label.order.order_number }}</small>
                <small class="mx-2">|</small>
                <small class="font-mono">{{ label.label_number }}</small>
                <small class="mx-2">|</small>
                <small class="font-mono">{{ pickupDate(label) }} {{ pickupTime(label) }} {{ label.order.shop ? label.order.shop.code : ''}}</small>
                <small class="mx-2">|</small>
                <span>
                  <svgicon name="money-a-solid" :class="{'opacity-0' : !label.order.payment_received}"/>
                </span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </report-orders>
  </vue-modal>
</template>

<script>
/* globals moment */
import modal from '../../mixins/modal';
import ReportOrders from './ReportOrders.vue';
import { ucfirst } from '../../core/helpers';

export default {
  mixins: [modal],

  components: { ReportOrders },

  methods: {
    pickupDate(label) {
      return ucfirst(
        moment(label.order.pickup_date).format('ddd DD/MM'),
      ).replace('.', '');
    },

    pickupTime(label) {
      if (!label.order.pickup_time) {
        return null;
      }
      return moment(label.order.pickup_time, 'HH:mm:ss').format('HH:mm');
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  &:last-child {
    border-bottom: none;
  }
  > :last-child svg {
    top: 4px;
  }
}

svg {
  position: relative;
  top: 2px;
}

@media print {
  .label {
    padding-top: 0;
    padding-bottom: 0;
    flex-direction: row;
  }
}
</style>
